<form *ngIf="loadPhones" nz-row novalidate
  [formGroup]="form"
  class="card-container-shadow padding-md"
  [ngClass]="{'card-container-shadow': !removeClassCardContainerShadow}">
  <div nz-col nzSpan="24">

    <!--Header-->
    <ng-container class="mb-sm">
      <div nz-row nzJustify="space-between" nzAlign="middle">
        <div nz-col class="text-subtitle-bold-upper" *ngIf="!withoutHeader">
          <p>Teléfonos</p>
        </div>
        <div nz-col *ngIf="!limit || this.phones.length <limit">
          <button nz-button [disabled]="disabled" class="btn-default
            align-self-end" type="button" nzType="default"
            (click)="onAddNewPhone()">
            <i nz-icon nzType="phone" nzTheme="outline"></i>
            Nuevo
          </button>
        </div>
      </div>
      <p class="text-info mb-xs" *ngIf="this.phones?.length> 0 && description">{{ description }}</p>
    </ng-container>
    <!-- /Header -->

    <!--Content-->
    <div>
      <div *ngFor="let phone of this.phoneWithId; index as i" [formGroupName]="phone.formId">
        <nz-select class="select-phone-type" formControlName="type" nzBorderless>
          <nz-option *ngFor="let type of phoneTypes" [nzValue]="type" [nzLabel]="type | getTranslateEnum:'phoneType'"></nz-option>
        </nz-select>
        <div class="d-flex tw-relative" @fadeInAnimation>
          <div class="element">
            <input
              maxlength="3"
              [ngStyle]="{'width': (phone.areaCode?.length + 1) + 'ch', 'min-width': '31px', 'max-width': '40px'}"
              [hidden]="!form.get(phone.formId).get('view').get('areaCode').value"
              type="text"
              #areaCode
              nz-input
              formControlName="areaCode"
              (blur)="onHideValue(phone.formId, 'areaCode', '---')"
              >
            <p *ngIf="!form.get(phone.formId).get('view').get('areaCode').value" (click)="onShowValue(phone.formId, 'areaCode', areaCode)">
              {{'(' + form.get(phone.formId).get('areaCodePlaceholder').value + ')'}}
            </p>
          </div>
          <div class="element">
            <!--  -->
            <input
              maxlength="7"
              [ngStyle]="{'min-width': '62px', 'max-width': '70px'}"
              [hidden]="!form.get(phone.formId).get('view').get('phoneNumber').value"
              type="text"
              #phoneNumber
              nz-input
              formControlName="phoneNumber"
              (blur)="onHideValue(phone.formId, 'phoneNumber','-------')"
              >
              <p *ngIf="!form.get(phone.formId).get('view').get('phoneNumber').value" (click)="onShowValue(phone.formId, 'phoneNumber', phoneNumber)">
                {{form.get(phone.formId).get('phoneNumberPlaceholder').value}}
              </p>
          </div>
          <div class="element ml-md">
            <span style="font-size: 12px; position: relative; top: 1px;">ext:</span>
          </div>
          <div class="element">
            <!-- -->
            <input
              maxlength="5"
              [ngStyle]="{'width': (phone.ext?.length + 1) + 'ch', 'min-width': '37px', 'max-width': '40px'}"
              [hidden]="!form.get(phone.formId).get('view').get('ext').value"
              type="text"
              #ext
              nz-input
              formControlName="ext"
              (blur)="onHideValue(phone.formId, 'ext', '---')"
              >
              <p *ngIf="!form.get(phone.formId).get('view').get('ext').value" (click)="onShowValue(phone.formId, 'ext', ext)">
                {{form.get(phone.formId).get('extPlaceholder').value}}
              </p>
          </div>
          <div nz-popover="" nzPopoverTitle="" nzPopoverContent="Eliminar" class="delete icon-action danger" (click)="onDeletePhoneNumber(phone.formId)">
            <i nz-icon nzType="delete" nzTheme="outline"></i>
          </div>
        </div>
        <p nz-typography [nzType]="'danger'" *ngIf="!form.get(phone.formId).valid" @fadeInAnimation style="font-size: 0.7em;">
          Campo inválido
        </p>
        <p nz-typography [nzType]="'danger'" *ngIf="phone.isEqual" @fadeInAnimation style="font-size: 0.7em;">
          Teléfono repetido
        </p>
      </div>
    </div>
  </div>
</form>
